import { render, staticRenderFns } from "./PaymentIndex.vue?vue&type=template&id=606a1927"
import script from "./PaymentIndex.vue?vue&type=script&lang=js"
export * from "./PaymentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports